import MomentUtils from '@date-io/moment';
import FuseAuthorization from '@fuse/core/FuseAuthorization';
import FuseLayout from '@fuse/core/FuseLayout';
import FuseTheme from '@fuse/core/FuseTheme';
import history from '@history';
import { createGenerateClassName, jssPreset, StylesProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { create } from 'jss';
import jssExtend from 'jss-plugin-extend';
import rtl from 'jss-rtl';
import React from 'react';
import Provider from 'react-redux/es/components/Provider';
import { Router } from 'react-router-dom';
import AppContext from './AppContext';
import { Auth } from './auth';
import routes from './fuse-configs/routesConfig';
import store from './store';
/* Added the following code for 962.Harsha using AI Agent. October 19, 2026. Code Start */
import NativeTitleTooltip from './components/NativeTitleTooltip';
import { createTheme, ThemeProvider as MuiV5ThemeProvider } from '@mui/material/styles';

/* Default arrow on all @mui Tooltip instances app-wide */
const muiV5TooltipTheme = createTheme({
	components: {
		MuiTooltip: {
			defaultProps: {
				arrow: true,
				placement: 'bottom'
			}
		}
	}
});
/* Code end. Harsha using AI Agent. October 19, 2026 */

const jss = create({
	...jssPreset(),
	plugins: [...jssPreset().plugins, jssExtend(), rtl()],
	insertionPoint: document.getElementById('jss-insertion-point')
});

const generateClassName = createGenerateClassName();

const App = () => {
	return (
		<AppContext.Provider
			value={{
				routes
			}}
		>
			<StylesProvider jss={jss} generateClassName={generateClassName}>
				<Provider store={store}>
					<MuiPickersUtilsProvider utils={MomentUtils}>
						<Auth>
							<Router history={history}>
								<FuseAuthorization>
									<FuseTheme>
										{/* Added the following code for 962.Harsha using AI Agent. October 19, 2026. Code Start */}
										<MuiV5ThemeProvider theme={muiV5TooltipTheme}>
											<FuseLayout />
											<NativeTitleTooltip />
										</MuiV5ThemeProvider>
										{/* Code end. Harsha using AI Agent. October 19, 2026 */}
									</FuseTheme>
								</FuseAuthorization>
							</Router>
						</Auth>
					</MuiPickersUtilsProvider>
				</Provider>
			</StylesProvider>
		</AppContext.Provider>
	);
};

export default App;
